export interface ProfileTab {
  hash: string
  label: string
  isRequired?: boolean
}

export const PROFILE_TABS: ProfileTab[] = [
  { hash: '#personal', label: '1. Personal *', isRequired: true },
  { hash: '#additional', label: '2. Additional Details *', isRequired: true },
  { hash: '#medical', label: '3. Medical History *', isRequired: true },
  { hash: '#environmental', label: '4. Environmental' },
  { hash: '#dental', label: '5. Dental' },
  { hash: '#exposures', label: '6. Genetics' },
]

export const TAB_HASHES = PROFILE_TABS.map((tab) => tab.hash)
export const TAB_LABELS = PROFILE_TABS.map((tab) => tab.label)
